import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Danish CPR validator following Single Responsibility Principle
 */
export class CprValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Danish CPR',
      pattern: /^\d{6}-?\d{4}$/,
      length: 10
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'CPR format must be DDMMYY-XXXX or DDMMYYXXXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/-/g, '');
    
    // CPR uses modulus 11 check
    const weights = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
    let sum = 0;
    
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleanId[i]) * weights[i];
    }

    if (sum % 11 !== 0) {
      return ValidationResult.invalid('Invalid CPR checksum');
    }

    return ValidationResult.valid('Valid CPR');
  }
}